import Paragraph from '@components/UI/Typography/Paragraph';
import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const FileUploaderMessage = ({ mods={} }) => {
    const { className } = useMods(FileUploaderMessage, { mods });

    return (
        <div
            className={ className }
        >
            <Paragraph
                tag='p'
                size='sm'
            >
                Drag and drop the file here to upload
            </Paragraph>
        </div>
    );
};

FileUploaderMessage.displayName = 'File-Uploader-Message';

FileUploaderMessage.propTypes = {
    mods: PropTypes.object
};

export default FileUploaderMessage;
